import { PLACE_BET_ERROR_CODE, PLACE_BET_ERROR_ACTION } from '@constants/bettingConstants'

// Codes that mean "the round wasn't open — try again next round" rather than
// "the bet is invalid". Everything else drops the bet back to IDLE.
const RETRYABLE = new Set([
  PLACE_BET_ERROR_CODE.BET_NOT_ALLOWED_NOW,
  PLACE_BET_ERROR_CODE.NO_ACTIVE_GAME,
])

// Pure. Given a PLACE_BET_RESPONSE failure `code`, decide the reaction.
export const classifyPlaceBetError = (code) =>
  RETRYABLE.has(code) ? PLACE_BET_ERROR_ACTION.RETRY : PLACE_BET_ERROR_ACTION.RESET
